import { AuthProvider } from 'hooks/useAuth';
import { CustomSnackBarProvider } from 'hooks/useCustomSnackbarProvider';
import React from 'react';

const AppProvider: React.FC = ({ children }) => {
  return (
    <AuthProvider>
      <CustomSnackBarProvider>{children}</CustomSnackBarProvider>
    </AuthProvider>
  );
};

export default AppProvider;
